module.exports = __webpack_public_path__ + "d488eb80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/feature_lightbox4_en.png
// module id = 1522
// module chunks = 0